import { fetchHighlightPlankProcess } from '@/apis/common/highlightPlankProcess'
import { fetchAllColor } from '@/apis/common/materialColor'
import { fetchAllMatCode } from '@/apis/common/materialMatCode'
import store from '@/store'
import jsrsasign from 'jsrsasign'

export const labelSources = ['orderNo', 'roomName', 'loc']
/**
 *
 * @param {[string]} arr 需要去掉的url参数
 * @returns 重组后的url
 */
function deleteUrlParam(arr) {
  let param = getUrlVars()
  for (let i = 0; i < arr.length; i++) {
    if (param.hasOwnProperty(arr[i])) {
      delete param[arr[i]]
    }
  }
  let paramStr = []
  for (let i in param) {
    paramStr.push(i + '=' + param[i])
  }
  paramStr = paramStr.join('&')
  // 获取router
  let routerStr = ''
  let router = window.location.href.split('#')
  if (router.length > 1) {
    router = router[1]
    router = router.split('?')
    routerStr = router[0]
  }
  let href = window.location.href.split('?')[0].split('#')[0]
  let url =
    href + (routerStr ? '#' + routerStr : '') + (paramStr ? '?' + paramStr : '')
  return url
}
function getUrlVars() {
  var vars = {},
    hash
  let url = window.location.href
  let hashes = []
  let temp1 = url.split('#')
  if (temp1.length > 1) {
    let temp2 = temp1[0].split('?')
    if (temp2.length > 1) {
      hashes = hashes = hashes.concat(temp2[1].split('&'))
    }
    temp2 = temp1[1].split('?')
    if (temp2.length > 1) {
      hashes = hashes = hashes.concat(temp2[1].split('&'))
    }
  } else {
    hashes = url.slice(url.indexOf('?') + 1).split('&')
  }
  // 判断浏览器是否兼容URLSearchParams, 如果不兼容则走简单的split
  try {
    if (url.includes('?')) {
      let searchUrl = window.location.href.split('?')[1]
      let params = new URLSearchParams(searchUrl)
      for (var i = 0; i < hashes.length; ++i) {
        hash = hashes[i].split('=')
        vars[hash[0]] = params.get(hash[0])
      }
    }
  } catch (err) {
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=')
      if (hash[0] == 'guigui_token') {
        let newHash = hash[1]
        if (newHash.includes('%')) {
          newHash = decodeURIComponent(newHash)
        } else if (!newHash.includes('=')) {
          newHash = newHash + '='
        }
        vars[hash[0]] = newHash
      } else {
        vars[hash[0]] = hash[1]
      }
    }
  }
  return vars
}
const priK = `-----BEGIN PRIVATE KEY-----
    MIICeQIBADANBgkqhkiG9w0BAQEFAASCAmMwggJfAgEAAoGBAK5eOnCsq8RGu0EV
    /2Ojott5txP7FKf2Bvo/f4rjZm8G8rgtMqFoXwxl4wpvvo3M1m8yUp2P+O2P5fro
    zpQwXcmah16W0PHQUv1qpYutxFZoNrhjsO5X8t9ROUyRhggmF19dFDH/Cuc46K5b
    FfgFqmdH84nwo5k24xWIP20r9xIZAgMBAAECgYEAmyv78d2YFlmjtq4u0qsC+TH9
    /OgKX9aQKw9rH1xzAgc65TBDyGQrgcsCG32KJILPqbEs2E8RhcfzMDER9cp9Cr2Q
    5CW492Fc4SNrRESEaOw0Qg9N79KAtIAL/qXuxaQg0FMpuddvG55na4m7LKgw6+Gv
    ChJgaakKSrDukcje2qECQQDhEW4cacy7QWDGuPs4M+QvNEdJ4yEU2KzyNDBZQbPB
    CRUZdsVIFoxhtcZsfmjNzEJS7cP37r3AhnJweNY0CaEtAkEAxlUFGxGJlwMdpOoQ
    TnpTcPywxFVDZavOn2Jh6BecsYJBtrAXxjL+/5pz59sDsKPleYAHVSVHb5E2/Blq
    PiEQHQJBAKPjN1UFTYmFf9z00ioIzz34SXjqJSqy5KyxiAtWpngIDw8tx1ZI5Qw5
    ezWBjvtco2cTr8GYXSAWRrrTotbdtDkCQQDCtnOFyKjxFkEDSDxsH5JN6fdNOXwq
    lAsN1VPTvWK7rur/BVDB6A0LOkKyjQXJZI8EwtnwEOJaORHnXLg+eM1NAkEAvhZE
    hBRKMXAF1FzJLjKgJw/ibc+nle0Bz6qX4/bd2BlzyZyIEC/hLKZwBOv8ZMZJTJAH
    zrsdbU5HAqvhp0JpKA==
    -----END PRIVATE KEY-----`
function calcKeyByRSA(newStr) {
  newStr = calcRsaKey(newStr)
  // 将密钥转码
  let rsa = jsrsasign.KEYUTIL.getKey(priK)
  var sig = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
  // 初始化
  sig.init(rsa)
  // 传入待加密字符串
  sig.updateString(newStr)
  // 生成密文
  var sign = jsrsasign.hextob64(sig.sign())
  // 对加密后内容进行URI编码
  sign = encodeURIComponent(sign)
  //把参数与密文拼接好，返回
  var params = sign
  return params
}
function calcRsaKey(obj) {
  let str = ''
  let arr = Object.keys(obj)
  // 按键名从小到大排序，验签传参需排序
  let sortArr = arr.sort((a, b) => a.localeCompare(b))
  for (let i = 0; i < sortArr.length; i++) {
    str += `&${sortArr[i]}=${obj[sortArr[i]]}`
  }
  str = str.slice(1)
  return str
}
export default {
  deleteUrlParam,
  getUrlVars,
  calcKeyByRSA,
  calcRsaKey,
}

export function cacleColorList(list) {
  const newList = []
  list.forEach((item) => {
    const currentItem = {
      value: item.color_name ?? item.name,
      label: item.color_name ?? item.name,
      children: null,
    }
    if (item.children) {
      currentItem.value = currentItem.value + '_catalog'
      currentItem.children = cacleColorList(item.children)
    }
    if (item.color) {
      const itemColors = item.color.map((e) => {
        return {
          label: e.color_name ?? e.name,
          value: e.color_name ?? e.name,
        }
      })
      currentItem.children = currentItem.children.concat(itemColors)
    }
    newList.push(currentItem)
  })
  return newList
}

export function checkColorIsExist(color, colorList, re = []) {
  if (!colorList.length) return false
  let isExist = false
  for (let i = 0; i < colorList.length; i++) {
    const item = colorList[i]
    if (item.children) {
      if (item.children.length) {
        const copyRe = JSON.parse(JSON.stringify(re))
        re.push(item.value)
        const hasExist = checkColorIsExist(color, item.children, re)

        if (!hasExist) {
          re = copyRe
        } else {
          isExist = true
          re = hasExist
          break
        }
      }
    } else {
      if (item.value == color) {
        re.push(item.value)
        isExist = true
        break
      }
    }
  }
  if (isExist) {
    return re
  } else return false
}

// 材质部分的判断
export function checkMatCodeIsExist(matCode, matcodeList) {
  // 检查数据里面是否已经存在matCode
  for (let item of matcodeList) {
    if (item.label === matCode || !matCode) {
      return true
    }
  }
  return false
}
export async function fetchMaterialMatCodes(needOther = true) {
  // 需要传入 参数需要uid
  const res = await fetchAllMatCode(store.state.userInfo.id)
  // 获取本地保存的数据
  const otherMatCodes = localStorage.getItem('matcodeList')
    ? JSON.parse(localStorage.getItem('matcodeList'))
    : []
  let resultList = []
  if (res && res?.status === 1) {
    resultList = res.data.map((item) => {
      return {
        label: item,
        value: item,
      }
    })
  }
  if (needOther) {
    resultList = resultList.concat(
      otherMatCodes.map((matCode) => ({
        label: matCode,
        value: matCode,
      }))
    )
  }

  return resultList
}
export async function fetchMaterialColors() {
  store.commit('setIsLoadingColors', true)
  const res = await fetchAllColor()
  store.commit('setIsLoadingColors', false)
  const otherColors = localStorage.getItem('colorList')
    ? JSON.parse(localStorage.getItem('colorList'))
    : []
  let resultList = []
  if (res && res.status) {
    resultList = cacleColorList(res.data)
  }
  resultList.push({
    value: 'other',
    label: '其他',
    children: otherColors.map((color) => ({
      label: color,
      value: color,
    })),
    leaf: false,
  })
  store.commit('setMaterialColorList', resultList)
}

// 用于翻译vue文件中导入的外部数据文本
export function translate(key, values) {
  if (key) {
    return window.i18n.t(key, values)
  } else {
    return ''
  }
}

/**
 * @description 对于浏览器的检测
 */
export class Browser {
  /** 是否是Edge */
  static isEdge() {
    // 使用静态缓存，缓存计算结果
    if (typeof this._isEdge !== 'undefined') return this._isEdge
    this._isEdge = /[E|e]dg/.test(window.navigator.userAgent)
    return this._isEdge
  }
}
export function judgeSourceData(arr, type = 'compare') {
  // 将超过限制数量的数据源放入overLimitSources
  const judgeLimitSource = {}
  for (let v of labelSources) {
    const result = []
    for (let item of arr) {
      if (
        !result.includes((type == 'compare' ? item[v] : item.part[v]) ?? '')
      ) {
        result.push((type == 'compare' ? item[v] : item.part[v]) ?? '')
      }
    }
    if (!judgeLimitSource[v]) {
      judgeLimitSource[v] = {}
    }
    judgeLimitSource[v] = result
  }
  return judgeLimitSource
}
// 生成范围内的随机整数[m,n]
export function randomInt(m, n) {
  return Math.floor(Math.random() * (n - m + 1)) + m
}
// 生成颜色对应的数据colorRes
export function genColorRes(judgeL) {
  const colorBase = {},
    colorRes = {}
  // 给定的12色 每个标签区域的颜色
  // 门板可能是用固定的颜色展示
  const colorList = [
    '#F9D7D9',
    '#FFDBB1',
    '#C3FFD6',
    '#89E1C5',
    '#EFD374',
    '#DFDA81',
    '#FBA5DA',
    '#DFCBFF',
    '#E4FAAC',
    '#C4EEAA',
    '#9BB4F3',
    '#CEF7FD',
  ]
  // 对于页面上只有余料板的时候，judgeL是空对象，不用走下面的逻辑直接返回
  if (JSON.stringify(judgeL) === '{}') return colorRes
  // 选中一个从对应的初始颜色库里面把这个颜色删除
  for (let source of labelSources) {
    // 设置初始颜色库
    colorBase[source] = [].concat(colorList)
    const sourceValue = judgeL[source]
    for (let key of sourceValue) {
      if (!colorRes[source]) {
        colorRes[source] = {}
      }
      const randomNum = randomInt(0, colorBase[source].length - 1)
      colorRes[source][key] = colorBase[source][randomNum]
      // 删除这个颜色，保证同种数据源不会重复到同一种颜色
      colorBase[source].splice(randomNum, 1)
    }
  }
  return colorRes
}
/** 矩形判断浮点容差 */
const RECT_EPS = 1e-6

function isNearRectPoint(p1, p2, eps = RECT_EPS) {
  return Math.abs(p1.x - p2.x) < eps && Math.abs(p1.y - p2.y) < eps
}

/**
 * 将路径归一为多边形角点：去闭合点、连续重复点、边上共线中间点
 * 多点矩形（边上插点）最终应只剩 4 个角点
 */
function simplifyToPolygonCorners(points, eps = RECT_EPS) {
  if (!points?.length) return []

  let pts = [...points]
  if (pts.length > 1 && isNearRectPoint(pts[0], pts[pts.length - 1], eps)) {
    pts.pop()
  }

  pts = pts.filter((p, i) => i === 0 || !isNearRectPoint(p, pts[i - 1], eps))
  if (pts.length < 3) return pts

  const corners = []
  const n = pts.length
  for (let i = 0; i < n; i++) {
    const prev = pts[(i - 1 + n) % n]
    const curr = pts[i]
    const next = pts[(i + 1) % n]
    const v1 = { x: curr.x - prev.x, y: curr.y - prev.y }
    const v2 = { x: next.x - curr.x, y: next.y - curr.y }
    const len1 = Math.hypot(v1.x, v1.y)
    const len2 = Math.hypot(v2.x, v2.y)
    if (len1 < eps || len2 < eps) continue
    // 叉积非 0 → 转向，保留为角点；共线中间点丢弃
    if (Math.abs(v1.x * v2.y - v1.y * v2.x) > eps) {
      corners.push(curr)
    }
  }
  return corners
}

/**
 * 传入坐标数据，判断是否构成矩形（支持旋转矩形）
 * 允许边上存在多余共线点、首尾闭合重复点；归一角点后须恰好 4 个
 */
export function judgeRectangle(points) {
  if (!points || points.length < 4) return false

  const corners = simplifyToPolygonCorners(points)
  if (corners.length !== 4) return false

  const [p1, p2, p3, p4] = corners
  const v1 = { x: p2.x - p1.x, y: p2.y - p1.y }
  const v2 = { x: p3.x - p2.x, y: p3.y - p2.y }
  const v3 = { x: p4.x - p3.x, y: p4.y - p3.y }
  const v4 = { x: p1.x - p4.x, y: p1.y - p4.y }

  const isPerpendicular = (a, b) => Math.abs(a.x * b.x + a.y * b.y) < RECT_EPS
  const length = (v) => Math.hypot(v.x, v.y)

  if (
    !isPerpendicular(v1, v2) ||
    !isPerpendicular(v2, v3) ||
    !isPerpendicular(v3, v4) ||
    !isPerpendicular(v4, v1)
  ) {
    return false
  }

  if (
    Math.abs(length(v1) - length(v3)) > RECT_EPS ||
    Math.abs(length(v2) - length(v4)) > RECT_EPS
  ) {
    return false
  }
  return true
}
/**
 * @description 模板规则匹配函数
 * @param customRectTemplate 自定义匹配规则
 * @param defaultTemplate 默认匹配规则
 * @param thick 当前裁剪的大板厚度
 */
export function matchTemplateRule(
  isSetCustomRect,
  customRectTemplate,
  defaultTemplate,
  thick
) {
  // 勾选了设置不同厚度板件最小裁剪尺寸 优先匹配自定义规则
  if (isSetCustomRect && customRectTemplate && customRectTemplate.length) {
    for (let template of customRectTemplate) {
      if (template.thickRect === Number(thick)) return template
    }
  }
  // 如果未命中 将使用默认模板的规则
  return defaultTemplate
}
/** @description 缓存高光板名称的数据 */
export async function cacheHighlightPlankProcess() {
  // 请求高光板接口的数据存储到store里面
  try {
    // 已经存储数据则不再请求
    if (store.state.highlightPlankNames.length !== 0) return
    const res = await fetchHighlightPlankProcess()
    if (res.status) {
      store.commit('setHighlightPlankNames', res.data)
    }
  } catch (err) {
    console.log('请求高光板名称出错', err)
    // 存一个默认数据 测试数据
    const testArrs = []
    store.commit('setHighlightPlankNames', testArrs)
  }
}
/**
 * @description 高光板名称匹配规则 需要根据材质去匹配对应的名称
 * @params matcode 板子的材质
 * @returns 返回找到的高光板的别名 xx/非xx
 */
const cacheData = {} // 缓存数据，避免多次重复查找
export function matchHighlightBoardName(matcode, flag = true) {
  // 获取store存储的高光名称数据
  const highlightPlankNames = store.state.highlightPlankNames
  // 避免遗漏处理
  matcode = restoreOriginalMatcode(matcode)
  // 查询缓存数据
  // if (cacheData[matcode]) {
  //   // return isHighlightPlank ? cacheData[matcode] : `非${cacheData[matcode]}`
  //   return cacheData[matcode]
  // }
  // 查询存储数据
  let alias = flag ? '高光板' : '高光' // 默认名称
  for (const highlightPlank of highlightPlankNames) {
    // 找到材质对应的高光别名数据
    if (highlightPlank.name === matcode) {
      if (highlightPlank.highlightPlankName) {
        alias = highlightPlank.highlightPlankName
      }
      // 退出循环
      break
    }
  }
  // 缓存数据
  // cacheData[matcode] = alias
  // return isHighlightPlank ? alias : `非${alias}`
  return alias
}
/** @description 还原原始材质   */
export function restoreOriginalMatcode(matcode) {
  if (matcode?.startsWith('高光_')) {
    const nMatcode = matcode.replace('高光_', '')
    return nMatcode
  }
  return matcode
}
/** @description 处理高光_材质 */
export function dealHighlightMatCode(matcode) {
  if (matcode?.startsWith('高光_')) {
    let matchKey = matchHighlightBoardName(
      restoreOriginalMatcode(matcode),
      false
    )
    return `${matchKey}_${restoreOriginalMatcode(matcode)}`
  }
  return matcode
}
/** @description 高光板搜索参数需要是旧逻辑的[高光_]以及别名名称的数据 */
export function getSurplusMatchTypes(highPlank, matCode) {
  const newMatCode = highPlank ? `高光_${matCode}` : matCode
  if (!highPlank) {
    return [newMatCode]
  }
  // 高光板需要两个名称一起匹配
  const typeList = [newMatCode, dealHighlightMatCode(newMatCode)].filter(
    Boolean
  )
  return [...new Set(typeList)]
}

/** @description 是否是高光大板 */
export function isHighBigPlank(plank) {
  return plank.highlight === '高光'
}

// 一维数组拆分成多维数组
export function chunkArray(arr, size) {
  const result = []
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size))
  }
  return result
}

/**
 * @description 根据斜边矩形的两个中心点坐标和宽度计算矩形路径
 * @param {Object} center1 第一个中心点坐标 {x: number, y: number}
 * @param {Object} center2 第二个中心点坐标 {x: number, y: number}
 * @param {number} width 矩形宽度
 * @returns {Array} 矩形四个顶点的路径数组 [{x, y}, {x, y}, {x, y}, {x, y}]
 */
export function calculateSlantedRectanglePath(center1, center2, width) {
  // 计算两个中心点之间的向量
  const dx = center2.x - center1.x
  const dy = center2.y - center1.y

  // 计算矩形的长度（两个中心点之间的距离）
  const length = Math.sqrt(dx * dx + dy * dy)

  // 计算单位向量（矩形长边的方向）
  const unitX = dx / length
  const unitY = dy / length

  // 计算垂直单位向量（矩形宽边的方向）
  const perpX = -unitY
  const perpY = unitX

  // 计算半宽度
  const halfWidth = width / 2

  // 计算四个顶点坐标
  // 顶点1：第一个中心点 + 垂直向量 * 半宽度
  const vertex1 = {
    x: center1.x + perpX * halfWidth,
    y: center1.y + perpY * halfWidth,
  }

  // 顶点2：第一个中心点 - 垂直向量 * 半宽度
  const vertex2 = {
    x: center1.x - perpX * halfWidth,
    y: center1.y - perpY * halfWidth,
  }

  // 顶点3：第二个中心点 - 垂直向量 * 半宽度
  const vertex3 = {
    x: center2.x - perpX * halfWidth,
    y: center2.y - perpY * halfWidth,
  }

  // 顶点4：第二个中心点 + 垂直向量 * 半宽度
  const vertex4 = {
    x: center2.x + perpX * halfWidth,
    y: center2.y + perpY * halfWidth,
  }

  // 返回按顺序排列的四个顶点，形成闭合路径
  return {
    path: [vertex1, vertex2, vertex3, vertex4, vertex1],
    length,
  }
}
/**
 * @description 将余料默认修边值添加到新增余料数据上
 * @param  surplus 新增余料数据
 */
export function dealNewSurplusTrimEdge(surplus) {
  const prefs = store.state.preferencesSetting.setting
  const trimData = prefs?.surplus_trim_data

  // 如果没有修边数据 普通粉色余料 或者是跟随标准板修边
  if (
    !trimData ||
    trimData.trimmingMethod === 'follow' ||
    !surplus.blueAreaSurplus
  ) {
    surplus.surplus_trim_edge = ''
    surplus.trimming_method = 'follow'
    return
  }

  // 如果是自定义模式
  if (trimData.trimmingMethod === 'custom') {
    if (trimData.isCustomTrim) {
      // 四边自定义修边
      surplus.surplus_trim_edge = [
        trimData.topTrim,
        trimData.bottomTrim,
        trimData.leftTrim,
        trimData.rightTrim,
      ].join(',')
    } else {
      // 单值修边
      surplus.surplus_trim_edge = trimData.trimValue
    }
    surplus.trimming_method = 'custom'
    return
  }

  // 默认
  surplus.surplus_trim_edge = ''
  surplus.trimming_method = 'follow'
}
